<template>
	<div class="demo-bar" v-if="!purchased || remainDays <= 7">
		<div v-if="!purchased">
			نسخه آزمایشی. اعتبار {{remainDays}} روز دیگر
			<v-btn color="secondary" small dark class="mx-1" @click="buy">
				خرید نرم افزار
			</v-btn>
		</div>
		<div v-else-if="remainDays <= 7">
			اعتبار نرم افزار {{remainDays}} روز دیگر به پایان می رسد.
			<v-btn color="secondary" small dark class="mx-1" @click="buy">
				تمدید اعتبار
			</v-btn>
		</div>
	</div>

</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'DemoBar',

		data: () => ({

		}),

		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			remainDays() {
				var user = this.getCurrentUser
				if (!user || !user.userData || !user.userData.customer)
					return ''
				const date1 = new Date()
				const date2 = new Date(user.userData.customer.expireDate)
				const diffTime = Math.max((date2 - date1), 0)
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
				return diffDays
			},
			purchased() {
				return this.getCurrentUser?.userData?.customer?.purchased
			},
		},

		methods: {
			randomColor() {
				this.color = this.colors[Math.floor(Math.random() * this.colors.length)]
			},
			buy() {
				this.$router.push('/admin/buy')
			}
		},
	}
</script>

<style scoped>
	.demo-bar {
		padding: 5px;
		background-color: #f44336;
		color: #fff;
		flex-basis: 100%;
		margin: -4px 0px 10px 0px;
	}
	.demo-bar > div {
		text-align: center;
	}
</style>
